/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/23/19
 * Time: 11:55 AM
 */
import React,{Component} from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import './MapView.css'
// import GoogleMap from "../../../../components/GoogleLocation/GoogleMap/Test_";
import GoogleMapView from "../../../../components/GoogleLocation/GoogleMap/GoogleMapView";
class App extends Component{
  toggle = () => {};
  render() {
    const {latLng} = this.props;
    const {location} = this.props;
    return (
      <MDBModal isOpen={true} toggle={this.toggle} size="md" side position="top-right">
        <MDBModalHeader className={"title-location"} toggle={this.props.closeModal}>View Branch Location</MDBModalHeader>
        <MDBModalBody style={{padding:'0px'}}>
          <GoogleMapView latitude={latLng.lat} longitude={latLng.lng} location={location} isMarkerShown/>
        </MDBModalBody>
      </MDBModal>
    );
  }
}

export default App;
